import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Camera, Calculator, Calendar, PackageCheck } from 'lucide-react';
const features = [{
  icon: BookOpen,
  title: '40 ideias com acabamento de boutique',
  description: 'Produtos testados que encantam clientes à primeira vista.'
}, {
  icon: Camera,
  title: 'Fotos de referência profissional',
  description: 'Imagens que ajudam você a vender e montar seu portfólio.'
}, {
  icon: Calculator,
  title: 'Lista de materiais com custo',
  description: 'Saiba exatamente quanto custa produzir cada unidade.'
}, {
  icon: Calendar,
  title: 'Ideias para todas as ocasiões',
  description: 'Aplicáveis para casamentos, festas e datas comemorativas.'
}, {
  icon: PackageCheck,
  title: 'Estrutura para produção e venda',
  description: 'Pensado para quem precisa de agilidade e lucro.'
}];
export function FeaturesSection() {
  return <section className="py-10 md:py-16 bg-stone-50" data-id="element-54">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8 md:mb-12" data-id="element-56">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-4" data-id="element-57">
            Um guia prático para quem vende lembrancinhas
          </h2>
          <p className="text-sm md:text-base text-stone-600" data-id="element-58">
            Tudo o que você precisa para profissionalizar seu portfólio
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto" data-id="element-59">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-white p-4 rounded-lg shadow-md border border-stone-100" data-id="element-60">
              <div className="bg-amber-100 w-10 h-10 rounded-lg flex items-center justify-center mb-3" data-id="element-61">
                <feature.icon className="w-5 h-5 text-amber-700" data-id="element-62" />
              </div>
              <h3 className="text-base font-bold text-stone-900 mb-1.5" data-id="element-63">
                {feature.title}
              </h3>
              <p className="text-stone-600 text-sm leading-relaxed" data-id="element-64">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}